// Libs
import classNames from 'classnames/bind';
import { useState } from 'react';
import { Stack } from '@mui/material';
// Components, Layouts, Pages
import { ClientKanban, ClientList } from '~/components/module/client';
// Others
import { PageEnum, TypeCrmEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './Client.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Client = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isTypePage, setIsTypePage] = useState<string>(PageEnum.KANBAN);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleOnChangeType = (value: string) => {
    setIsTypePage(value);
  };
  //#endregion Handle Function

  return (
    <Stack id='clientPage' className={cx('container')}>
      {/* {isTypePage === PageEnum.KANBAN ? (
        <ClientKanban isTypePage={isTypePage} onChangeType={handleOnChangeType} />
      ) : ( */}
      <ClientList isTypePage={isTypePage} onChangeType={handleOnChangeType} typeList={TypeCrmEnum.CLIENT} />
      {/* )} */}
    </Stack>
  );
};

export default Client;
